<div class="page-header">
  <div>
    <h1>{{ t('ProcessPageLink') }}</h1>
    <p>{{ t('HubProcessesIntro').replace('{environment}', peerEnvironment) }}</p>
  </div>
  @if (session?.user?.processAdmin) {
    <button class="primary-button" type="button" (click)="createModalOpen = true">{{ t('AddProcessDefinitionButton') }}</button>
  }
</div>

@if (error) {
  <p class="message error">{{ error }}</p>
}
@if (success) {
  <p class="message success">{{ success }}</p>
}
@if (loading) {
  <p>{{ t('HubProcessesLoading') }}</p>
}

@if (!loading) {
  <div class="card">
    <table class="table">
      <thead>
        <tr>
          <th>{{ t('ProcessDefinitionName') }}</th>
          <th>{{ t('ProcessDefinitionDisplayName') }}</th>
          <th>{{ t('processType') }}</th>
          <th>{{ t('HubActions') }}</th>
        </tr>
      </thead>
      <tbody>
        @for (process of processes; track process) {
          <tr>
            <td [attr.data-label]="t('ProcessDefinitionName')"><a class="row-link process-name-link" [routerLink]="['/processes', process.processDefinitionId, 'edit']"><wa-icon name="diagram-3"></wa-icon>{{ process.name }}</a></td>
            <td [attr.data-label]="t('ProcessDefinitionDisplayName')">{{ process.displayName }}</td>
            <td [attr.data-label]="t('processType')">{{ process.type }}</td>
            <td [attr.data-label]="t('HubActions')">
              <a class="secondary-button action-link" [routerLink]="['/processes', process.processDefinitionId, 'edit']">{{ t('HubOpenEditor') }}</a>
              @if (session?.user?.processAdmin) {
                <button
                  class="secondary-button"
                  type="button"
                  (click)="copyToPeer(process)"
                >{{ copyButtonLabel() }}</button>
              }
            </td>
          </tr>
        }
        @if (processes.length === 0) {
          <tr>
            <td colspan="4">{{ t('HubNoProcesses') }}</td>
          </tr>
        }
      </tbody>
    </table>
  </div>
}

@if (createModalOpen) {
  <div class="modal-backdrop" (click)="closeCreateModal()">
    <form class="modal-card" (click)="$event.stopPropagation()" (ngSubmit)="createProcess()">
      <h2>{{ t('AddProcessDefinitionButton') }}</h2>
      <label>{{ t('ProcessDefinitionNameLabel') }}<input name="newProcessName" [(ngModel)]="newProcessName" required autofocus></label>
      <div class="button-row">
        <button class="secondary-button" type="button" (click)="closeCreateModal()">{{ t('DeleteFormCancelButtonLabel') }}</button>
        <button class="primary-button" type="submit">{{ t('HubCreate') }}</button>
      </div>
    </form>
  </div>
}
